import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, Component, ChangeDetectionStrategy, ViewEncapsulation, Optional, Inject, NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import * as i3 from '@angular/material/legacy-button';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import * as i5 from '@angular/material/legacy-select';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import * as i7 from '@angular/material/legacy-tooltip';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import * as i1 from '@angular/material/paginator';
import { _MatPaginatorBase, MAT_PAGINATOR_INTL_PROVIDER } from '@angular/material/paginator';
function MatLegacyPaginator_div_2_mat_form_field_3_mat_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pageSizeOption_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", pageSizeOption_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", pageSizeOption_r3, " ");
  }
}
function MatLegacyPaginator_div_2_mat_form_field_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 16)(1, "mat-select", 17);
    i0.ɵɵlistener("selectionChange", function MatLegacyPaginator_div_2_mat_form_field_3_Template_mat_select_selectionChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._changePageSize($event.value));
    });
    i0.ɵɵtemplate(2, MatLegacyPaginator_div_2_mat_form_field_3_mat_option_2_Template, 2, 2, "mat-option", 18);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("appearance", ctx_r1._formFieldAppearance)("color", ctx_r1.color);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.pageSize)("disabled", ctx_r1.disabled)("panelClass", ctx_r1.selectConfig.panelClass || "")("disableOptionCentering", ctx_r1.selectConfig.disableOptionCentering)("aria-label", ctx_r1._intl.itemsPerPageLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._displayedPageSizeOptions);
  }
}
function MatLegacyPaginator_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.pageSize);
  }
}
function MatLegacyPaginator_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MatLegacyPaginator_div_2_mat_form_field_3_Template, 3, 8, "mat-form-field", 14)(4, MatLegacyPaginator_div_2_div_4_Template, 2, 1, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1._intl.itemsPerPageLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._displayedPageSizeOptions.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._displayedPageSizeOptions.length <= 1);
  }
}
function MatLegacyPaginator_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function MatLegacyPaginator_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.firstPage());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 7);
    i0.ɵɵelement(2, "path", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r1._intl.firstPageLabel)("matTooltipDisabled", ctx_r1._previousButtonsDisabled())("matTooltipPosition", "above")("disabled", ctx_r1._previousButtonsDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1._intl.firstPageLabel);
  }
}
function MatLegacyPaginator_button_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function MatLegacyPaginator_button_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.lastPage());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 7);
    i0.ɵɵelement(2, "path", 24);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matTooltip", ctx_r1._intl.lastPageLabel)("matTooltipDisabled", ctx_r1._nextButtonsDisabled())("matTooltipPosition", "above")("disabled", ctx_r1._nextButtonsDisabled());
    i0.ɵɵattribute("aria-label", ctx_r1._intl.lastPageLabel);
  }
}
export { PageEvent as LegacyPageEvent, MAT_PAGINATOR_INTL_PROVIDER as MAT_LEGACY_PAGINATOR_INTL_PROVIDER, MAT_PAGINATOR_INTL_PROVIDER_FACTORY as MAT_LEGACY_PAGINATOR_INTL_PROVIDER_FACTORY, MatPaginatorIntl as MatLegacyPaginatorIntl, _MatPaginatorBase as _MatLegacyPaginatorBase } from '@angular/material/paginator';
import * as i4 from '@angular/material/legacy-form-field';
import * as i6 from '@angular/material/legacy-core';

/**
 * Injection token that can be used to provide the default options for the paginator module.
 * @deprecated Use `MAT_PAGINATOR_DEFAULT_OPTIONS` from `@angular/material/paginator` instead. See https://material.angular.io/guide/mdc-migration for information about migrating.
 * @breaking-change 17.0.0
 */
const MAT_LEGACY_PAGINATOR_DEFAULT_OPTIONS = /*#__PURE__*/new InjectionToken('MAT_LEGACY_PAGINATOR_DEFAULT_OPTIONS');
/**
 * Component to provide navigation between paged information. Displays the size of the current
 * page, user-selectable options to change that size, what items are being shown, and
 * navigational button to go to the previous or next page.
 * @deprecated Use `MatPaginator` from `@angular/material/paginator` instead. See https://material.angular.io/guide/mdc-migration for information about migrating.
 * @breaking-change 17.0.0
 */
let MatLegacyPaginator = /*#__PURE__*/(() => {
  class MatLegacyPaginator extends _MatPaginatorBase {
    constructor(intl, changeDetectorRef, defaults) {
      super(intl, changeDetectorRef, defaults);
      if (defaults && defaults.formFieldAppearance != null) {
        this._formFieldAppearance = defaults.formFieldAppearance;
      }
    }
    static {
      this.ɵfac = function MatLegacyPaginator_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatLegacyPaginator)(i0.ɵɵdirectiveInject(i1.MatPaginatorIntl), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(MAT_LEGACY_PAGINATOR_DEFAULT_OPTIONS, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatLegacyPaginator,
        selectors: [["mat-paginator"]],
        hostAttrs: ["role", "group", 1, "mat-paginator"],
        inputs: {
          disabled: "disabled"
        },
        exportAs: ["matPaginator"],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 14,
        vars: 14,
        consts: [[1, "mat-paginator-outer-container"], [1, "mat-paginator-container"], ["class", "mat-paginator-page-size", 4, "ngIf"], [1, "mat-paginator-range-actions"], [1, "mat-paginator-range-label"], ["mat-icon-button", "", "type", "button", "class", "mat-paginator-navigation-first", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-previous", 3, "click", "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled"], ["viewBox", "0 0 24 24", "focusable", "false", "aria-hidden", "true", 1, "mat-paginator-icon"], ["d", "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-next", 3, "click", "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled"], ["d", "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"], ["mat-icon-button", "", "type", "button", "class", "mat-paginator-navigation-last", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click", 4, "ngIf"], [1, "mat-paginator-page-size"], [1, "mat-paginator-page-size-label"], ["class", "mat-paginator-page-size-select", 3, "appearance", "color", 4, "ngIf"], ["class", "mat-paginator-page-size-value", 4, "ngIf"], [1, "mat-paginator-page-size-select", 3, "appearance", "color"], [3, "selectionChange", "value", "disabled", "panelClass", "disableOptionCentering", "aria-label"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "mat-paginator-page-size-value"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-first", 3, "click", "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled"], ["d", "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-last", 3, "click", "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled"], ["d", "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"]],
        template: function MatLegacyPaginator_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, MatLegacyPaginator_div_2_Template, 5, 3, "div", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, MatLegacyPaginator_button_6_Template, 3, 5, "button", 5);
            i0.ɵɵelementStart(7, "button", 6);
            i0.ɵɵlistener("click", function MatLegacyPaginator_Template_button_click_7_listener() {
              return ctx.previousPage();
            });
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(8, "svg", 7);
            i0.ɵɵelement(9, "path", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵnamespaceHTML();
            i0.ɵɵelementStart(10, "button", 9);
            i0.ɵɵlistener("click", function MatLegacyPaginator_Template_button_click_10_listener() {
              return ctx.nextPage();
            });
            i0.ɵɵnamespaceSVG();
            i0.ɵɵelementStart(11, "svg", 7);
            i0.ɵɵelement(12, "path", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(13, MatLegacyPaginator_button_13_Template, 3, 5, "button", 11);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.hidePageSize);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx._intl.getRangeLabel(ctx.pageIndex, ctx.pageSize, ctx.length), " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showFirstLastButtons);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matTooltip", ctx._intl.previousPageLabel)("matTooltipDisabled", ctx._previousButtonsDisabled())("matTooltipPosition", "above")("disabled", ctx._previousButtonsDisabled());
            i0.ɵɵattribute("aria-label", ctx._intl.previousPageLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matTooltip", ctx._intl.nextPageLabel)("matTooltipDisabled", ctx._nextButtonsDisabled())("matTooltipPosition", "above")("disabled", ctx._nextButtonsDisabled());
            i0.ɵɵattribute("aria-label", ctx._intl.nextPageLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showFirstLastButtons);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i3.MatLegacyButton, i4.MatLegacyFormField, i5.MatLegacySelect, i6.MatLegacyOption, i7.MatLegacyTooltip],
        styles: [".mat-paginator{display:block}.mat-paginator-outer-container{display:flex}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;padding:0 8px;flex-wrap:wrap-reverse;width:100%}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}[dir=rtl] .mat-paginator-page-size{margin-right:0;margin-left:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0 4px;width:56px}.mat-paginator-page-size-select.mat-form-field-appearance-outline{width:64px}.mat-paginator-page-size-select.mat-form-field-appearance-fill{width:64px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center}.mat-paginator-icon{display:inline-block;width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}.cdk-high-contrast-active .mat-paginator-icon{fill:CanvasText}"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MatLegacyPaginator;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated Use `MatPaginatorModule` from `@angular/material/paginator` instead. See https://material.angular.io/guide/mdc-migration for information about migrating.
 * @breaking-change 17.0.0
 */
let MatLegacyPaginatorModule = /*#__PURE__*/(() => {
  class MatLegacyPaginatorModule {
    static {
      this.ɵfac = function MatLegacyPaginatorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatLegacyPaginatorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MatLegacyPaginatorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [MAT_PAGINATOR_INTL_PROVIDER],
        imports: [CommonModule, MatLegacyButtonModule, MatLegacySelectModule, MatLegacyTooltipModule, MatCommonModule]
      });
    }
  }
  return MatLegacyPaginatorModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MAT_LEGACY_PAGINATOR_DEFAULT_OPTIONS, MatLegacyPaginator, MatLegacyPaginatorModule };
